import React from 'react';
import {useField} from 'formik';
import IconPicker from '../IconPicker';

interface FormikIconPickerProps {
  name: string;
}

/**
 * @deprecated No new uses.
 */
export default function FormikIconPicker(props: FormikIconPickerProps): React.ReactElement {
  const [field, , helpers] = useField(props.name);

  return <IconPicker onSelect={helpers.setValue} value={field.value} />;
}
